import { Box } from '@mui/material';
import { type WithRouter, withRouter } from 'found';
import React, { useEffect, useState } from 'react';

import { spaces } from '../assets/styles/themes/tokens';
import ChangeEmailError from '../components/ChangeEmail/ChangeEmailError';
import ChangeEmailLoading from '../components/ChangeEmail/ChangeEmailLoading';
import ChangeEmailSuccess from '../components/ChangeEmail/ChangeEmailSuccess';
import PageContainer from '../components/login/PageContainer';
import services from '../services';

type ChangeEmailProps = WithRouter;

const ChangeEmailConfirm: React.FC<ChangeEmailProps> = (props) => {
	const {
		match: {
			location: {
				query: { token },
			},
		},
	} = props;

	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		services.user
			.confirmNewEmail(token)
			.catch(() => setHasError(true))
			.finally(() => setIsLoading(false));
	}, [token]);

	return (
		<PageContainer pageBodySx={{ gap: 0 }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					paddingY: spaces.xxxxxl,
				}}
			>
				{isLoading && <ChangeEmailLoading />}
				{hasError && <ChangeEmailError />}
				{!isLoading && !hasError && <ChangeEmailSuccess />}
			</Box>
		</PageContainer>
	);
};

export default withRouter(ChangeEmailConfirm);
